/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreContinueRedirectWithPiResponse
 */
export interface FxIdWebFeaturesStoreContinueRedirectWithPiResponse {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreContinueRedirectWithPiResponse
     */
    RedirectUrl: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreContinueRedirectWithPiResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreContinueRedirectWithPiResponse(value: object): value is FxIdWebFeaturesStoreContinueRedirectWithPiResponse {
    if (!('RedirectUrl' in value) || value['RedirectUrl'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreContinueRedirectWithPiResponseFromJSON(json: any): FxIdWebFeaturesStoreContinueRedirectWithPiResponse {
    return FxIdWebFeaturesStoreContinueRedirectWithPiResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreContinueRedirectWithPiResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreContinueRedirectWithPiResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'RedirectUrl': json['RedirectUrl'],
    };
}

export function FxIdWebFeaturesStoreContinueRedirectWithPiResponseToJSON(json: any): FxIdWebFeaturesStoreContinueRedirectWithPiResponse {
    return FxIdWebFeaturesStoreContinueRedirectWithPiResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreContinueRedirectWithPiResponseToJSONTyped(value?: FxIdWebFeaturesStoreContinueRedirectWithPiResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'RedirectUrl': value['RedirectUrl'],
    };
}

